import { observer } from 'mobx-react'
import React, { Suspense, useCallback, useEffect } from 'react'
import CostCentreCollection from '../../State/Collections/CostCentreCollection'

import PageHeader from '../Layout/PageHeader'
import { canEditCostCentres } from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'

export default observer(({ extraContent }) => {
    return (
        <PageHeader
            heading={
                <div>
                    <div>{'Cost Centres'}</div>
                </div>
            }
            extraContent={
                canEditCostCentres(SessionStore.user) ? (
                    <button
                        className="btn btn-default add-timesheet-entry-button plus-btn mt-6"
                        onClick={() => {
                            const ph = CostCentreCollection.add(
                                { isBillable: true },
                                { trackUpdates: true }
                            )
                            ph.isNew = true
                        }}
                    >
                        + Add Cost Centre
                    </button>
                ) : null
            }
        />
    )
})
